/* 🤖 this file was generated by svg-to-ts */
export const iconCentils: {
  name: 'centils';
  data: string;
} = {
  name: 'centils',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><g fill="none" fill-rule="evenodd" stroke="#767676" stroke-dasharray="1 2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 17c.897-1.899 2.685-3.578 5.363-5.037C9.04 10.503 12.586 9.516 17 9"/><path d="M1 15.7c.836-2.838 2.606-5.158 5.31-6.96C9.015 6.935 12.578 5.7 17 5.031"/><path d="M1 14.351c.61-3.657 2.274-6.62 4.993-8.89C8.712 3.194 12.38 1.706 17 1"/></g></svg>`,
};
